function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* global React, window, Wordmark, Icon, Button, Eyebrow */
// ============================================================================
// Footer — activist brand. Working links, accurate Printful terms.
// ============================================================================
var _React = React,
  useStateFt = _React.useState;

function Footer(_ref) {
  var onNav = _ref.onNav;
  var COLS = [
    {
      h: "Shop",
      links: [
        { label: "New Arrivals", href: "/?collection=new-arrivals" },
        { label: "Best Sellers", href: "/?collection=best-sellers" },
        { label: "Women's Tees", href: "/?collection=womens-tees" },
        { label: "Unisex Tees", href: "/?collection=unisex-tees" },
        { label: "Hoodies", href: "/?collection=hoodies" },
        { label: "Accessories", href: "/?collection=accessories" }
      ]
    },
    {
      h: "Movement",
      links: [
        { label: "The Dispatch", href: "/blogs/the-dispatch" },
        { label: "LGBTQ+ Pride", href: "/?collection=lgbtq-pride" },
        { label: "Feminist", href: "/?collection=feminist" },
        { label: "Protest", href: "/?collection=protest" },
        { label: "Submit Your Art", href: "/pages/submit-your-art" },
        { label: "Artist FAQ", href: "/pages/artist-faq" }
      ]
    },
    {
      h: "Help",
      links: [
        { label: "Shipping & Returns", href: "/policies/shipping-policy" },
        { label: "Refund Policy", href: "/policies/refund-policy" },
        { label: "Privacy Policy", href: "/policies/privacy-policy" },
        { label: "Terms of Service", href: "/policies/terms-of-service" },
        { label: "Contact Us", href: "mailto:hello@rebelsandrights.store" },
        { label: "Size Guide", href: "/?page=size-guide" }
      ]
    },
    {
      h: "Brand",
      links: [
        { label: "About Us", href: "/pages/about" },
        { label: "Our Mission", href: "/pages/about#mission" },
        { label: "The Dispatch Blog", href: "/blogs/the-dispatch" },
        { label: "Press Enquiries", href: "mailto:press@rebelsandrights.store" },
        { label: "Artist Program", href: "/pages/submit-your-art" }
      ]
    }
  ];

  return /*#__PURE__*/React.createElement("footer", {
    style: { background: "var(--bone)", borderTop: "1px solid var(--line)" }
  },
  /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: { paddingTop: 80, paddingBottom: 56 }
  },
  /*#__PURE__*/React.createElement("div", {
    style: { display: "grid", gridTemplateColumns: "1.4fr repeat(4, 1fr)", gap: 64 },
    className: "responsive-footer-grid"
  },
  /*#__PURE__*/React.createElement("div", null,
    /*#__PURE__*/React.createElement(Wordmark, { height: 48 }),
    /*#__PURE__*/React.createElement("p", {
      style: {
        marginTop: 24, maxWidth: 320,
        fontFamily: "var(--font-serif)", fontStyle: "italic",
        fontSize: 18, lineHeight: 1.55, color: "var(--muted)"
      }
    }, "Activist apparel for people who give a damn. Designed in Brooklyn, printed on demand in Los Angeles, profit-shared with the movement."),
    /*#__PURE__*/React.createElement("div", {
      style: { display: "flex", gap: 8, marginTop: 28 }
    },
    [
      { ic: "instagram", l: "Instagram", href: "https://instagram.com/rebelsandrights" },
      { ic: "tiktok", l: "TikTok", href: "https://tiktok.com/@rebelsandrights" },
      { ic: "twitter", l: "Twitter/X", href: "https://x.com/RebelsAndRights" }
    ].map(function(s) {
      return /*#__PURE__*/React.createElement(SocialIcon, { key: s.ic, ic: s.ic, l: s.l, href: s.href });
    })),
    /*#__PURE__*/React.createElement("p", {
      style: {
        marginTop: 28, fontSize: 11, color: "var(--muted)",
        lineHeight: 1.6, fontFamily: "var(--font-sans)"
      }
    }, "Printed on demand by Printful in Los Angeles. Ships in 3–5 business days. Returns accepted for defective items within 30 days of delivery.")
  ),
  COLS.map(function(col) {
    return /*#__PURE__*/React.createElement("div", { key: col.h },
      /*#__PURE__*/React.createElement("div", {
        style: {
          fontFamily: "var(--font-sans)", fontWeight: 500, fontSize: 11,
          letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--muted)",
          paddingBottom: 18, borderBottom: "1px solid var(--line)", marginBottom: 18
        }
      }, col.h),
      /*#__PURE__*/React.createElement("ul", {
        style: { listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12 }
      },
      col.links.map(function(link) {
        return /*#__PURE__*/React.createElement("li", { key: link.label },
          /*#__PURE__*/React.createElement(FootLink, { href: link.href, onNav: onNav, label: link.label }, link.label)
        );
      }))
    );
  })
  )),
  /*#__PURE__*/React.createElement("div", {
    style: { borderTop: "1px solid var(--line)", padding: "48px 0", overflow: "hidden" }
  },
  /*#__PURE__*/React.createElement("div", { className: "container" },
    /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: "var(--font-serif)", fontSize: "clamp(64px, 14vw, 240px)",
        lineHeight: 0.86, fontStyle: "italic", fontWeight: 400, textAlign: "center",
        letterSpacing: "-0.03em", color: "var(--ink)", textWrap: "balance"
      }
    }, "Rebels & Rights", /*#__PURE__*/React.createElement("span", { style: { color: "var(--rust)" } }, ".")),
    /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: 24, textAlign: "center", fontFamily: "var(--font-sans)",
        fontSize: 12, letterSpacing: "0.18em", color: "var(--muted)", textTransform: "uppercase"
      }
    }, "Wear what you believe — established 2021")
  )),
  /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      padding: "20px 32px 28px", borderTop: "1px solid var(--line)",
      display: "flex", justifyContent: "space-between", alignItems: "center",
      flexWrap: "wrap", gap: 16
    }
  },
  /*#__PURE__*/React.createElement("div", {
    style: { fontFamily: "var(--font-sans)", fontSize: 11, color: "var(--muted)", letterSpacing: "0.06em" }
  }, "\xA9 2026 Rebels & Rights \xB7 Brooklyn, NY"),
  /*#__PURE__*/React.createElement("div", {
    style: { display: "flex", gap: 24, flexWrap: "wrap", fontSize: 11, color: "var(--muted)" }
  },
  [
    { label: "Privacy", href: "/policies/privacy-policy" },
    { label: "Terms", href: "/policies/terms-of-service" },
    { label: "Refunds", href: "/policies/refund-policy" },
    { label: "Accessibility", href: "mailto:hello@rebelsandrights.store" }
  ].map(function(link) {
    return /*#__PURE__*/React.createElement("a", {
      key: link.label, href: link.href,
      style: { color: "var(--muted)", textDecoration: "none" },
      onMouseEnter: function(e) { e.currentTarget.style.color = "var(--ink)"; },
      onMouseLeave: function(e) { e.currentTarget.style.color = "var(--muted)"; }
    }, link.label);
  })
  )),
  /*#__PURE__*/React.createElement("style", null, "\n        @media (max-width: 1024px) {\n          .responsive-footer-grid { grid-template-columns: 1fr 1fr 1fr !important; }\n          .responsive-footer-grid > div:first-child { grid-column: 1 / -1; }\n        }\n        @media (max-width: 640px) {\n          .responsive-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 40px !important; }\n          .responsive-footer-grid > div:first-child { grid-column: 1 / -1; }\n        }\n      "));
}

function FootLink(_ref2) {
  var children = _ref2.children, href = _ref2.href, onNav = _ref2.onNav, label = _ref2.label;
  var _useStateFt = useStateFt(false),
    _useStateFt2 = _slicedToArray(_useStateFt, 2),
    hover = _useStateFt2[0], setHover = _useStateFt2[1];
  
  // Internal collection nav
  var handleClick = function(e) {
    if (href && href.startsWith('/?collection=') && onNav) {
      e.preventDefault();
      onNav(href.replace('/?collection=', ''));
    }
  };
  
  return /*#__PURE__*/React.createElement("a", {
    href: href || "#",
    onClick: handleClick,
    onMouseEnter: function() { return setHover(true); },
    onMouseLeave: function() { return setHover(false); },
    style: {
      display: "inline-flex", alignItems: "center",
      gap: hover ? 12 : 0,
      fontFamily: "var(--font-sans)", fontSize: 14,
      color: hover ? "var(--rust)" : "var(--ink)",
      textDecoration: "none",
      transition: "color 140ms, gap 200ms"
    }
  }, hover && /*#__PURE__*/React.createElement("span", { style: { width: 10, height: 1, background: "var(--rust)" } }), children);
}

function SocialIcon(_ref3) {
  var ic = _ref3.ic, l = _ref3.l, href = _ref3.href;
  var _useStateFt3 = useStateFt(false),
    _useStateFt4 = _slicedToArray(_useStateFt3, 2),
    hover = _useStateFt4[0], setHover = _useStateFt4[1];
  return /*#__PURE__*/React.createElement("a", {
    href: href || "#",
    target: "_blank", rel: "noopener noreferrer",
    "aria-label": l,
    onMouseEnter: function() { return setHover(true); },
    onMouseLeave: function() { return setHover(false); },
    style: {
      width: 36, height: 36,
      border: "1px solid " + (hover ? "var(--ink)" : "var(--line-2)"),
      background: hover ? "var(--ink)" : "transparent",
      color: hover ? "var(--bone)" : "var(--ink)",
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      textDecoration: "none", transition: "all 160ms"
    }
  }, /*#__PURE__*/React.createElement(Icon, { name: ic, size: 16 }));
}

Object.assign(window, { Footer: Footer });
